import { IPoint2d } from '@/editor/math/IPoint2d';
import { getUniqueId } from '@/editor/utils';
import { ENTITY_LATER, ENTITY_RENDER_ORDER, floor2dDisabledColor } from '@/editor/constant/entity';
import { EEntityType } from '@/editor/types';
import { Mesh, MeshBasicMaterial, ShapeGeometry } from 'three';
import { pathToGmtShape } from '@/editor/utils/shape';

class MaskPlane {
  private _id: string;
  private _path: IPoint2d[];
  private _floorMesh: Mesh;
  private _type: EEntityType;
  private _material: MeshBasicMaterial;
  private _holes: IPoint2d[][];

  constructor(path: IPoint2d[], holes: IPoint2d[][], type: EEntityType) {
    this._path = path;
    this._holes = holes;
    this._type = type;
    this._id = getUniqueId(); // 生成一个唯一的ID

    const geometry = this.createMaskFloorEntGeometry();
    this._material = new MeshBasicMaterial({ color: floor2dDisabledColor });
    this._floorMesh = new Mesh(geometry, this._material);
    this._floorMesh.renderOrder =
      this._type === EEntityType.Region ? ENTITY_RENDER_ORDER.region + 1 : ENTITY_RENDER_ORDER.floor + 1;
    this._floorMesh.userData.type = type;
    this._floorMesh.userData.priority = 1;
    this._floorMesh.material = this._material;
    // 它带着 userData.type/priority，又挂在 intersectableGroup 下的 regionModel 里，
    // 靠图层把自己从拾取中排除掉（射线不看 visible，隐藏时也会被命中）
    this._floorMesh.layers.set(ENTITY_LATER.MASK_PLANE_LAYER);
    this._floorMesh.visible = false;
  }

  private createMaskFloorEntGeometry() {
    // const heartShape = new Shape();
    // const len = this._path.length;
    // for (let i = 0; i < len; i++) {
    //   if (i === 0) {
    //     heartShape.moveTo(this._path[i].x / pixelRatio2d, this._path[i].y / pixelRatio2d);
    //   } else {
    //     heartShape.lineTo(this._path[i].x / pixelRatio2d, this._path[i].y / pixelRatio2d);
    //   }
    // }

    // for (const hole of this._holes) {
    //   const holePath = new Path();
    //   const len = hole.length;
    //   for (let i = 0; i < len; i++) {
    //     if (i === 0) {
    //       holePath.moveTo(hole[i].x / pixelRatio2d, hole[i].y / pixelRatio2d);
    //     } else {
    //       holePath.lineTo(hole[i].x / pixelRatio2d, hole[i].y / pixelRatio2d);
    //     }
    //   }

    //   heartShape.holes.push(holePath);
    // }

    // const geometry = new ShapeGeometry(heartShape);
    // return geometry;
    const shape = pathToGmtShape(this._path, this._holes);
    const geometry = new ShapeGeometry(shape);
    return geometry;
  }

  updateMaskFloorPlane(path: IPoint2d[], holes: IPoint2d[][] = []) {
    this._path = path;
    this._holes = holes;
    const geometry = this.createMaskFloorEntGeometry();
    if (geometry) {
      this._floorMesh.geometry.dispose();
      this._floorMesh.geometry = geometry;
    }
  }

  setVisible(enable: boolean) {
    this._floorMesh.visible = !!enable;
  }

  get path() {
    return this._path;
  }

  get id() {
    return this._id;
  }

  get floorMesh() {
    return this._floorMesh;
  }
}

export default MaskPlane;
